/**!
 * Created by Leonardo Cheslacki on 30/04/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import AnimateController from './../AnimateController';

let _this = {};

/**
 *
 */
class GamesController extends AnimateController {
    /**
     *
     */
    constructor() {
        super();
        _this = this;
    };

    /**
     *
     * @param occurrence
     * @param pseudo
     * @returns {string|*}
     */
    getPseudo = (occurrence, pseudo) => {
        return this.verifyField(occurrence, `occ_pseudo_${pseudo}`);
    };

    /**
     *
     * @param current_frame
     * @returns {{}}
     */
    findDataFrame = (current_frame) => {
        const {data_frames} = this.props;

        return data_frames.find(({frame}) => (frame === current_frame));
    };

    /**
     *
     * @param current_frame
     * @returns {*}
     */
    findActivity = (current_frame) => {
        const {activities} = this.state;

        return activities.find(({frame}) => (frame === current_frame));
    };

    /**
     *
     * @param current_frame
     * @param _id
     * @returns {*}
     */
    findAnswer = (current_frame, _id) => {
        const {answers} = this.findActivity(current_frame);

        return answers.find(({button}) => (button === _id));
    };

    /**
     *
     * @param _key
     * @returns {*}
     */
    findTack = (_key) => {
        const {tracks} = this.state;

        return tracks.find(({key}) => (key === _key));
    };

    /**
     *
     * @param frame
     * @param handle
     * @returns {(function(): void)|*}
     */
    setAnswers = (frame, handle = null) => () => {
        const {occ_response} = this.get();

        this.gotoAndStopFrame(occ_response, this.$current_frame);

        const _this_frame = this.getFrame(occ_response);

        this.gotoAndStopFrame(_this_frame, frame);

        if (typeof (handle) === 'function') {
            switch (frame) {
                case 2:
                    this.readAudioSay(this.findTack('reset'));
                    this._handleResetAnswers && _this_frame.btn_reset.off('mousedown', this._handleResetAnswers);
                    this._handleResetAnswers = _this_frame.btn_reset.on('mousedown', handle);
                    break;
                case 3:
                    this.readAudioSay(this.findTack('continue'));
                    this._handleContinueAnswers && _this_frame.btn_continue.off('mousedown', this._handleContinueAnswers);
                    this._handleContinueAnswers = _this_frame.btn_continue.on('mousedown', handle);
                    break;
                case 4:
                    this.readAudioSay(this.findTack('finish'));
                    this._handleFinishAnswers && _this_frame.btn_finish.off('mousedown', this._handleFinishAnswers);
                    this._handleFinishAnswers = _this_frame.btn_finish.on('mousedown', handle);
                    break;
            }
        }
    };

    /**
     *
     * @param property
     */
    disableTitle = (property) => {
        const
            _this_frame = this.getFrame(),
            occ = `occ_title_${this.padWithLeadingZeros(property, 2)}`;

        this.effectFadeOut(_this_frame, occ, () => {
            _this_frame[occ].visible = false;
        });
    };

    /**
     *
     * @param right
     */
    getHeart = (right = false) => {
        const
            _this_current = this.get(),
            {properties} = this.getComposition().getLibrary(),
            {life} = this.state;

        const
            occ_left = this.verifyField(_this_current, 'occ_heart'),
            occ_right = this.verifyField(_this_current, 'occ_heart_right');

        for (let i = 0; i < life; i++) {
            let
                key = (i + 1),
                occ_heart_clone = (occ_left && occ_left.clone()) || (occ_right && occ_right.clone()),
                {width, height} = occ_heart_clone.nominalBounds,
                x = 0,
                y = 0;

            this.gotoAndStopFrame(occ_heart_clone.occ_animate_heart, 2);

            occ_heart_clone.name = `occ_heart_${this.padWithLeadingZeros(key, 2)}`;

            if (occ_right) {
                x = (properties.width - (((width * key) + (i * 10)) + width));
            } else {
                x = ((width * key) + (i * 10));
            }

            y = height;

            occ_heart_clone.setTransform(x, y);

            _this_current.addChild(occ_heart_clone);
        }
    };

    /**
     *
     * @param data
     * @param callback
     */
    getGrid = (data, callback) => {
        const {rows, cols} = data;

        for (let row = 0; row < rows; row++) {
            for (let col = 0; col < cols; col++) {
                (typeof (callback) === 'function') && callback(row, col);
            }
        }
    };
}

export default GamesController;
